import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { AppProviders } from "./providers/AppProviders";
import MissingConfig from "./components/MissingConfig";
import { firebaseConfigValid, missingFirebaseVars } from "./services/firebase";

// Clean up stale auth-storage from previous Zustand persist config.
// Firebase Auth handles its own persistence — the Zustand key is no longer used.
try {
  localStorage.removeItem("auth-storage");
} catch {
  // localStorage unavailable — nothing to clean up.
}

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  firebaseConfigValid ? (
    <AppProviders>
      <App />
    </AppProviders>
  ) : (
    <MissingConfig vars={missingFirebaseVars} />
  )
);
